import { graphql } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'
import { locale, textWithLocale } from '../../../src/common/i18n/index'
import { SeoData } from '../../../src/common/types/Seo'

interface Props {
  seoData: SeoData | null
}
function Seo({ seoData }: Props) {
  if (seoData) {
    const catalanUrl = `${process.env.GATSBY_WEB_URL_ca}${seoData.url_ca}`
    const espUrl = `${process.env.GATSBY_WEB_URL_es}${seoData.url_es}`
    const currentUrl = locale === 'ca' ? catalanUrl : espUrl
    return (
      <Helmet>
        <html lang={locale === 'ca' ? 'ca-ES' : 'es-ES'} />
        <title>{seoData[textWithLocale('titulo')]}</title>
        <meta
          name="description"
          content={seoData[textWithLocale('descripcion')]}
        />
        <link rel="alternate" hrefLang="es-ES" href={espUrl} />
        <link rel="alternate" hrefLang="ca-ES" href={catalanUrl} />
        <link rel="canonical" href={currentUrl} />
        <meta property="og:title" content={seoData[textWithLocale('titulo')]} />
        <meta
          property="og:description"
          content={seoData[textWithLocale('descripcion')]}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={currentUrl} />
        <meta name="keywords" content={seoData[textWithLocale('keywords')]} />
        {seoData.url_imagen && (
          <meta property="og:image" content={seoData.url_imagen} />
        )}

        {Object.keys(seoData.twitter_meta || {}).map((item) => (
          <meta
            name={`twitter:${item}`}
            key={item}
            content={seoData.twitter_meta[item]}
          />
        ))}
      </Helmet>
    )
  }
  return null
}

export const query = graphql`
  fragment seoinformation on PageInfo {
    url_es
    url_ca
    titulo_es
    titulo_ca
    titulo_pt
    descripcion_ca
    descripcion_es
    descripcion_pt
    keywords_ca
    keywords_es
    keywords_pt
  }
`

export default Seo
